import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from '@mui/material';
import { ROUTES } from '@/utils/constants';
import { QUERY_KEYS } from '@/utils/constants/query-keys';
import { HeaderEvents } from '@/misc/event-enums';
import { sendGoogleGTMEvent } from '@/utils/googleGTM';
const SignInUpButton = () => {
  const pathname = usePathname();
  const onClick = () => {
    sendGoogleGTMEvent({
      event: 'log_reg_click'
    });
  };
  return <Link href={`${ROUTES.login.href}?${QUERY_KEYS.redirectTo}=${pathname}`} data-sentry-element="Link" data-sentry-component="SignInUpButton" data-sentry-source-file="SignInUpButton.tsx">
      <Button variant='contained' color='primary' onClick={onClick} sx={{
      typography: {
        xs: 'captionRegular__Wallfund',
        sm: 'bodyMedium__Wallfund'
      }
    }} data-gtm-button-id={HeaderEvents.NavBarSignup} data-sentry-element="Button" data-sentry-source-file="SignInUpButton.tsx">
        ورود / ثبت‌نام
      </Button>
    </Link>;
};
export default SignInUpButton;